import { render, staticRenderFns } from "./customDashboardTable.vue?vue&type=template&id=63f9d1a2&scoped=true"
import script from "./customDashboardTable.vue?vue&type=script&lang=js"
export * from "./customDashboardTable.vue?vue&type=script&lang=js"
import style0 from "./customDashboardTable.vue?vue&type=style&index=0&id=63f9d1a2&prod&lang=scss&scoped=true"
import style1 from "./customDashboardTable.vue?vue&type=style&index=1&id=63f9d1a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9d1a2",
  null
  
)

export default component.exports